import { ISODateString } from './types'

const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/

/**
 * Whether the string is an ISO date without a time
 * 2024-06-23 => true
 * 2024-06-23T07:23:35.299Z => false
 *
 * Only the shape is checked, not whether
 * the day exists in the calendar
 *
 * @param value
 */
export function isIsoDateString(
  value: string
): value is ISODateString {
  return ISO_DATE.test(value)
}

/**
 * Parse a date string (2024-06-23) to a Date instance
 * at midnight UTC on that day.
 *
 * Read the day back with the UTC parts
 * (see formatUtcIsoDate) so it is the same
 * in every timezone
 *
 * @param isoDate
 */
export function parseIsoDateAsUtc(isoDate: ISODateString) {
  return new Date(`${isoDate}T00:00:00Z`)
}
